import { ProfessionalRadioGroup } from "@/components/Auth/shared";
import { SelectInput } from "@/components/shared/FormInputs";
import type { Specialty } from "@/types/auth";
import type { WaitlistFormFieldErrors } from "@/types/waitlist";
import { cn } from "@paribus/shared-ui";

interface WaitlistStepProfessionalProps {
  visible: boolean;
  isProfessional: boolean;
  specialtyId: string;
  specialties: Specialty[];
  errors: WaitlistFormFieldErrors;
  onIsProfessionalChange: (checked: boolean) => void;
  onSpecialtyIdChange: (value: string) => void;
}

export const WaitlistStepProfessional = ({
  visible,
  isProfessional,
  specialtyId,
  specialties,
  errors,
  onIsProfessionalChange,
  onSpecialtyIdChange,
}: WaitlistStepProfessionalProps) => {
  const specialtyOptions = specialties.map((s) => ({
    value: s.specialty_id,
    label: s.specialty_name,
  }));

  return (
    <div
      className={cn(
        "transition-all duration-300",
        visible ? "block animate-in fade-in slide-in-from-right-4" : "hidden"
      )}
    >
      <ProfessionalRadioGroup
        isProfessional={isProfessional}
        onIsProfessionalChange={onIsProfessionalChange}
      />

      {isProfessional && (
        <div className="duration-300 animate-in fade-in slide-in-from-top-2">
          <SelectInput
            label="Specialty"
            value={specialtyId}
            options={specialtyOptions}
            placeholder="Select your specialty"
            onChange={onSpecialtyIdChange}
            error={errors.specialty}
          />
        </div>
      )}
    </div>
  );
};
